import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AiOutlineClockCircle, AiOutlineCalendar } from 'react-icons/ai';
import dayjs from 'dayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import api from '../api/api';
import DatePicker from 'react-datepicker'; // Import DatePicker
import "react-datepicker/dist/react-datepicker.css"; // Import styles
import ToastMessage from '../utils/mui/righttoptoast';
const ConfigModal = ({ handlecloseConfig, providerConfig }) => {
    const [configData,setConfigData]=useState(null);
   const [isLoading, setLoading] = useState(false);
   const practiseid = window.getPracticeId();

    const [timeSlots, setTimeSlots] = useState([]);
    const [duration, setDuration] = useState('');
    const [selectedDays, setSelectedDays] = useState([]);
    const [blockedDates, setBlockedDates] = useState([ ]);
    const [newTimeSlot, setNewTimeSlot] = useState({ start: '', end: '' });
    const [newBlockedDate, setNewBlockedDate] = useState({ start: '', end: '' });
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
   const handleCloseToast = () => {
    setToast((prev) => ({ ...prev, open: false }));
  };
    const toggleDay = (day) => {
        setSelectedDays((prev) => prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]);
    };

    const removeTimeSlot = (index) => {
        setTimeSlots((prev) => prev.filter((_, i) => i !== index));
    };

    const removeBlockedDate = (index) => {
        setBlockedDates((prev) => prev.filter((_, i) => i !== index));
    };

    const handleAddTimeSlot = () => {
        if (newTimeSlot.start && newTimeSlot.end) {
            // Format start and end times to include AM/PM
            const formatTime = (time) => {
                const date = new Date(`1970-01-01T${time}`);
                let formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    
                // Remove leading zero for hours (e.g., "08:30" becomes "8:30")
                formattedTime = formattedTime.replace(/^0/, '');
    
                // Add spaces around the colon
                return formattedTime.replace(':', ' : ');
            };
    
            const formattedStart = formatTime(newTimeSlot.start);
            const formattedEnd = formatTime(newTimeSlot.end);
    
            setTimeSlots((prev) => [...prev, { start: formattedStart, end: formattedEnd }]);
        }
    };
    
    

    const handleAddBlockedDate = () => {
        if (newBlockedDate.start && newBlockedDate.end) {
            // Helper function to format the date to MM-DD-YYYY
            const formatDate = (date) => {
                const d = new Date(date);
                const month = d.getMonth() + 1; // Months are zero-indexed
                const day = d.getDate();
                const year = d.getFullYear();
                return `${month}-${day}-${year}`;
            };
    
            // Format both start and end dates
            const formattedStart = formatDate(newBlockedDate.start);
            const formattedEnd = formatDate(newBlockedDate.end);
    
            // Add the newly formatted date to the blockedDates array
            setBlockedDates((prev) => [
                ...prev,
                { start: formattedStart, end: formattedEnd }
            ]);
    
            // Reset the input fields
            setNewBlockedDate({ start: '', end: '' });
        }
    };
    
  

     const fetchConfigData = async () => {
        setLoading(true); // Start loading
        try {
            const response = await api.get(`/v1/${practiseid}/provider/${providerConfig.providerid}/data`);
            if (response.status === 200) {
                const data = response.provider.config;
                // Update state with response data
                setConfigData(data);
                if (data) {
                    setTimeSlots(data.availabletimings.map(slot => {
                        const [start, end] = slot.split(' - ');
                        return { start, end };
                    }));
                    setSelectedDays(data.availableDays);
                    setDuration(data.timeduration);
                    setBlockedDates(data.blockedDates.map(date => {
                        const [start, end] = date.split(' - ');
                        return { start, end };
                    }));
                }

            } else {
                setConfigData([]); // Empty privileges if no data is found
            }
        } catch (error) {
            console.error(error); // Log any errors
        } finally {
            setLoading(false); // Stop loading
        }
    };
    useEffect(()=>{
       fetchConfigData()
    },[providerConfig])
const generateTimeSlots = (timeSlots, duration) => {
  const slots = [];

  timeSlots.forEach(({ start, end }) => {
    // parse your existing "8 : 00 AM" format
    let startTime = dayjs(start, "h : mm A");
    const endTime = dayjs(end, "h : mm A");

    while (startTime.isBefore(endTime)) {
      slots.push(startTime.format("HH:mm")); // ✅ 24-hour format
      startTime = startTime.add(Number(duration), "minute");
    }
  });

  return slots;
};

const generateBlockedDays = (blockedDates) => {
  const days = [];

  blockedDates.forEach(({ start, end }) => {
    let current = dayjs(start, "M-D-YYYY");
    const endDate = dayjs(end, "M-D-YYYY");

    while (current.isSameOrBefore(endDate)) {
      days.push(current.format("M-D-YYYY"));
      current = current.add(1, "day");
    }
  });

  return days;
};

   const fetchUpdateConfigData = async (providerConfig) => {
  setLoading(true);
console.log(providerConfig,'provider')
  const payload = {
    config: {
      providerid: providerConfig.providerid,
provider:providerConfig.username,
      // convert array to API format
      availabletimings: timeSlots.map(
        slot => `${slot.start} - ${slot.end}`
      ),
timeSlots:generateTimeSlots(timeSlots, duration),
      timeduration: duration,
      availableDays: selectedDays,
weekDays:selectedDays,
blockeddays:generateBlockedDays(blockedDates),
      blockedDates: blockedDates.map(
        date => `${date.start} - ${date.end}`
      ),
    },
  };

  try {
    const response = await api.put(
      `/v1/${practiseid}/provider/config`,
      payload
    );

    if (response.status === 200) {
      console.log("Data updated successfully");
     setToast({ open: true, message: 'Data updated successfully', severity: 'success' });


    }else{
          setToast({ open: true, message: response?.message||'Something Went wrong', severity: 'info' });
    }
  } catch (error) {
    console.error(error);
    setToast({ open: true, message: 'Something Went wrong', severity: 'error' });
  } finally {
    setLoading(false);
  }
};

    return (<>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
            <div className="relative flex flex-col w-[50%] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
                <div className="flex justify-between items-center border-b pb-2">
                    <h3 className="font-semibold text-lg">Update Provider Configuration</h3>
                    <IconButton onClick={handlecloseConfig} className="text-gray-600 hover:text-gray-700">
                        <CloseIcon fontSize="medium" />
                    </IconButton>
                </div>
                <div className="p-2 space-y-4">
                    <div className='font-semibold'>Available Time Slots</div>
                    <div className="flex justify-between gap-4">
  {/* Start Time */}
  <div className="flex flex-col w-1/2 font-medium">
    <label>Start Time</label>
    <input
      type="time"
      value={newTimeSlot.start}
      onChange={(e) => setNewTimeSlot({ ...newTimeSlot, start: e.target.value })}
      className="p-1 border rounded w-full"
    />
  </div>

  {/* End Time */}
  <div className="flex flex-col w-1/2 font-medium">
    <label>End Time</label>
    <input
      type="time"
      value={newTimeSlot.end}
      onChange={(e) => setNewTimeSlot({ ...newTimeSlot, end: e.target.value })}
      className="p-1 border rounded w-full"
    />
  </div>
</div>



                        <button
                            onClick={handleAddTimeSlot}
                            className="py-1 px-3 border-2 font-medium border-gray-200  rounded"
                        >
                         +   Add Time Slot
                        </button>
                        <div className="flex flex-wrap gap-2">
    {timeSlots.map((slot, index) => (
        <div key={index} className="flex items-center border-[1.5px] font-medium border-gray-200 p-1 rounded">
            <AccessTimeIcon style={{ width: '14px' }} />
            <span className='ml-1'>{slot.start} - {slot.end}</span>
            <div onClick={() => removeTimeSlot(index)} className="text-red-500 cursor-pointer flex items-center justify-center ml-1 w-6 rounded-full bg-orange-100">
                <CloseIcon style={{width:'17px'}} />
            </div>
        </div>
    ))}
</div>

               

                    <div className="border-t pt-2 font-medium">Duration per Patient (minutes)</div>
                    <div className="w-[30%]">
                        <input
                            type="number"
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                            className="w-full p-2 border rounded"
                        />
                    </div>

                    <div className='font-medium'>Days of the Week</div>
                    <div className="flex space-x-2">
                        {['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].map((day) => (
                            <button
                                key={day}
                                onClick={() => toggleDay(day)}
                                className={`py-1 px-3 rounded ${selectedDays.includes(day) ? 'bg-black text-white' : 'bg-gray-200'}`}
                            >
                                {day}
                            </button>
                        ))}
                    </div>

                    <div className='font-medium'>Blocked Dates</div>
                    <div className="flex relative space-x-2">
                    <div onClick={() => setIsDatePickerOpen(!isDatePickerOpen)} className="flex items-center border-[1.5px] border-gray-200 p-1 rounded">
                    <AiOutlineCalendar   style={{ width: '14px' }} />
                    <span className="ml-1">
                        {newBlockedDate.start && newBlockedDate.end
                            ? `${newBlockedDate.start.toLocaleDateString()} - ${newBlockedDate.end.toLocaleDateString()}`
                            : 'Select Date'}
                    </span>
                    </div>
                {/* Show the DatePicker when isDatePickerOpen is true */}
                <div className='absolute font-medium bottom-9'>
                {isDatePickerOpen && (
                    <DatePicker
                        selected={newBlockedDate.start}
                        onChange={(dates) => {
                            const [start, end] = dates;
                            setNewBlockedDate({ start, end });
                        }}
                        startDate={newBlockedDate.start}
                        endDate={newBlockedDate.end}
                        selectsRange
                        inline
                        dateFormat="MM/dd/yyyy"
                    />
                )}
                </div>
                <button
    onClick={() => {
        setIsDatePickerOpen(false);  // Close the DatePicker
        handleAddBlockedDate();      // Call the handleAddBlockedDate function
    }}
    className="py-1 px-3 border-2 font-medium rounded"
>
    +   Add
</button>

                    </div>
                    <div className="flex flex-wrap gap-2">
    {blockedDates.map((date, index) => (
        <div key={index} className="flex items-center border-[1.5px] font-medium border-gray-200 p-1 rounded">
            <CalendarTodayIcon style={{ width: '14px' }} />
            <span className="ml-1">
                {/* Format the dates before rendering */}
                {dayjs(date.start).format('MM/DD/YYYY')} - {dayjs(date.end).format('MM/DD/YYYY')}
            </span>
            <div onClick={() => removeBlockedDate(index)} className="text-red-500 cursor-pointer flex items-center justify-center ml-1 w-6 rounded-full bg-orange-100">
                <CloseIcon style={{ width: '17px' }} />
            </div>
        </div>
    ))}
</div>

                </div>

                <div className="flex justify-end gap-2 mt-4">
                    <button 
                    onClick={()=>fetchUpdateConfigData(providerConfig)}
                     className="py-1 px-4 bg-black text-white rounded-lg">Update</button>
                </div>
            </div>
            
        </div>
    
       <ToastMessage
              message={toast.message}
              severity={toast.severity}
              open={toast.open}
              handleClose={handleCloseToast}
            />
    </>);
};

export default ConfigModal;
